export const TIME_FORMAT = "HH:mm";
